import styles from './index.less';
import CustomerDefaultInformation from '@/components/CustomerDefaultInformation';
import CustomerAccountInformation from '@/components/CustomerAccountInformation';
import { useModel } from '@umijs/max';
import { Collapse, Divider } from 'react-vant';
import { queryAccountInformationDetailList } from '@/pages/Mine/My/service';
import { useSafeState } from 'ahooks';
import { AccountInformationDetailType } from '@/pages/Mine/interface';
const AccountInformation = () => {
  const { accountDetailList } = useModel('useAccount', (model) => ({
    accountList: model.accountList,
    accountDetailList: model.accountDetailList,
  }));
  const [accountInformationDetailList, setAccountInformationDetailList] =
    useSafeState<AccountInformationDetailType[]>([]);

  const loadAccountInformationDetailList = (accountNo: string) => {
    queryAccountInformationDetailList({ accountNo: accountNo }).then((res) => {
      if (res?.code === 200) {
        if (res?.rows) {
          setAccountInformationDetailList(res?.rows);
        }
      }
    });
  };

  const handleChange = (value: string | number | (string | number)[]) => {
    if (value && typeof value === 'string') {
      loadAccountInformationDetailList(value);
    }
  };

  return (
    <div>
      <CustomerDefaultInformation />
      <CustomerAccountInformation />
      <div className={styles.content}>
        <Collapse accordion onChange={handleChange}>
          {accountDetailList.map((item) => (
            <Collapse.Item
              key={item.accountNo}
              title={item.accountName}
              name={item.accountNo}
              value={item.balance}
            >
              <div className={styles.accountDetail}>
                <div className={styles.title}>
                  <p>类型</p>
                  <p>金额</p>
                  <p>结余</p>
                  <p style={{ width: '40%', textAlign: 'center' }}>交易时间</p>
                </div>
                {accountInformationDetailList.map((item, index: number) => (
                  <div key={item.sequenceNbr} className={styles.accountList}>
                    <div className={styles.listContainer}>
                      <p>{item?.postscript}</p>
                      <p>{item.changeAmount}</p>
                      <p>{item.finalBalance}</p>
                      <p style={{ width: '40%', textAlign: 'center' }}>
                        {item.recDate}
                      </p>
                    </div>
                    {index !== accountInformationDetailList.length - 1 && (
                      <Divider
                        style={{
                          '--rv-divider-margin': 0,
                          color: '#F3F3F3',
                        }}
                      />
                    )}
                  </div>
                ))}
              </div>
            </Collapse.Item>
          ))}
        </Collapse>
      </div>
    </div>
  );
};

export default AccountInformation;
